import { useEffect, useState } from "react";
import { getSupplierRecommendationInsights } from "services/supplierRecommendationService";

export default function useSupplierRecommendationInsights({ active, entityId, userId, rfqId, supplierIds = [], source = "MARKETPLACE", vendors = [] }) {
  const supplierKey = JSON.stringify(source === "INTERNAL"
    ? vendors.map((vendor) => ({ vendorId: String(vendor.vendorId), ...(vendor.supplierId == null ? {} : { supplierId: vendor.supplierId }) }))
      .sort((a, b) => a.vendorId.localeCompare(b.vendorId))
    : [...new Set(supplierIds.map(String))].sort());
  const key = JSON.stringify([entityId, userId, rfqId, source, supplierKey]);
  const enabled = Boolean(active && entityId && userId && supplierKey !== "[]");
  const [result, setResult] = useState({ key: "", status: "idle", bySupplierId: {} });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    let current = true;
    setResult({ key, status: "loading", bySupplierId: {} });
    getSupplierRecommendationInsights({
      entityId, source,
      ...(source === "INTERNAL" ? { vendors: JSON.parse(supplierKey) } : { supplierIds: JSON.parse(supplierKey) }),
      signal: controller.signal,
    })
      .then((payload) => {
        if (!current) return;
        setResult({
          key, status: "ready", canViewTrustedCompanies: payload.canViewTrustedCompanies,
          bySupplierId: Object.fromEntries(payload.items.map((item) => [String(item.supplierId), item])),
        });
      })
      .catch(() => {
        if (current) setResult({ key, status: "error", bySupplierId: {} });
      });
    return () => { current = false; controller.abort(); };
  }, [enabled, key, entityId, source, supplierKey, attempt]);

  return {
    ...(enabled && result.key === key ? result : { status: enabled ? "loading" : "idle", bySupplierId: {} }),
    retry: () => setAttempt((value) => value + 1),
  };
}
